// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listfile {
  display: flex;
  max-width: 100%;
  margin-right: 32px;
}
.listfilesetting {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: sticky;
  top: 0;
  border-bottom: 1px solid whitesmoke;
  border-radius: 5px;
}

.listfilesetting svg {
  font-size: 20px;
  margin-top: 14px;
}
.listfilesetting .settingleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.listfilesetting .settingleft svg {
  margin: 0 1px;
}
.Dropdown {
  margin: 0 auto;
  height: 30px;
  min-width: 170px;
  width: -moz-fit-content;
  width: fit-content;
  border: none;
  margin-bottom: 2px;
}
.Dropdown:hover {
  cursor: pointer;
}
.listbody {
  display: flex;
  flex-direction: column;
  height: 36px;
  margin-top: 15px;
}
.searchbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  background-color: whitesmoke;
  border-radius: 10px;
  min-width: 300px;
}
.searchbar svg {
  font-size: 20px;
  /* padding: 10px 10px; */
}

.searchbar input {
  border: 0;
  background-color: transparent;
  outline: 0;
  flex: 1 1;
  font-size: 15px;
}

.listbody .sp {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 380px;
  border: 1px solid rgba(0, 0, 0, 0.217);
  margin: 1px;
}
.listbody .sp:hover {
  cursor: pointer;
  background-color: azure;
  box-shadow: 2px 2px 10px gray;
}
.flexing {
  display: grid;
  grid-template-columns: repeat(5, 390px);
  grid-template-rows: repeat(10, 50px);
  grid-auto-flow: column;
}
@media (max-width: 2300px) {
  .flexing {
    grid-template-columns: repeat(4, 390px);
    grid-template-rows: repeat(13, 50px);
  }
}
@media (max-width: 1707px) {
  .flexing {
    grid-template-columns: repeat(3, 390px);
    grid-template-rows: repeat(25, 50px);
  }
}
@media (width: 1024px) {
  .flexing {
    grid-template-columns: repeat(1, 390px);
    /* grid-template-rows: repeat(17, 50px); */
    grid-auto-flow: row;
  }
}

/* @media (max-width: 2304px) {
  .flexing {
    grid-template-columns: repeat(5, 400px);
    grid-template-rows: repeat(10, 50px);
  }
} */

.listbody .sp .listbody-right p {
  max-width: 303px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown {
  padding: 5px;
}
.dropdown .selectfolder {
  height: 30px;
  border: none;
  border-radius: 5px;
}
.addtobutton {
  margin-top: 10px !important;
  margin-left: 5px !important;
  height: 30px !important;
  border: solid 0.5px black !important;
}
.statusmessage {
  padding: 34px;
  border: 4px black solid;
  display: flex;
  flex-direction: column;
  width: 300px;
  height: -moz-fit-content;
  height: fit-content;
  background-color: rgb(195, 210, 235);
  position: absolute;
  top: 45%;
  left: 40%;
}
`, "",{"version":3,"sources":["webpack://./src/components/NewCreateCollection/features/css/listfile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE;IACE,uCAAuC;IACvC,oCAAoC;EACtC;AACF;AACA;EACE;IACE,uCAAuC;IACvC,oCAAoC;EACtC;AACF;AACA;EACE;IACE,uCAAuC;IACvC,0CAA0C;IAC1C,mBAAmB;EACrB;AACF;;AAEA;;;;;GAKG;;AAEH;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAmB;EAAnB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX","sourcesContent":[".listfile {\n  display: flex;\n  max-width: 100%;\n  margin-right: 32px;\n}\n.listfilesetting {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: sticky;\n  top: 0;\n  border-bottom: 1px solid whitesmoke;\n  border-radius: 5px;\n}\n\n.listfilesetting svg {\n  font-size: 20px;\n  margin-top: 14px;\n}\n.listfilesetting .settingleft {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.listfilesetting .settingleft svg {\n  margin: 0 1px;\n}\n.Dropdown {\n  margin: 0 auto;\n  height: 30px;\n  min-width: 170px;\n  width: fit-content;\n  border: none;\n  margin-bottom: 2px;\n}\n.Dropdown:hover {\n  cursor: pointer;\n}\n.listbody {\n  display: flex;\n  flex-direction: column;\n  height: 36px;\n  margin-top: 15px;\n}\n.searchbar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 10px;\n  background-color: whitesmoke;\n  border-radius: 10px;\n  min-width: 300px;\n}\n.searchbar svg {\n  font-size: 20px;\n  /* padding: 10px 10px; */\n}\n\n.searchbar input {\n  border: 0;\n  background-color: transparent;\n  outline: 0;\n  flex: 1;\n  font-size: 15px;\n}\n\n.listbody .sp {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 380px;\n  border: 1px solid rgba(0, 0, 0, 0.217);\n  margin: 1px;\n}\n.listbody .sp:hover {\n  cursor: pointer;\n  background-color: azure;\n  box-shadow: 2px 2px 10px gray;\n}\n.flexing {\n  display: grid;\n  grid-template-columns: repeat(5, 390px);\n  grid-template-rows: repeat(10, 50px);\n  grid-auto-flow: column;\n}\n@media (max-width: 2300px) {\n  .flexing {\n    grid-template-columns: repeat(4, 390px);\n    grid-template-rows: repeat(13, 50px);\n  }\n}\n@media (max-width: 1707px) {\n  .flexing {\n    grid-template-columns: repeat(3, 390px);\n    grid-template-rows: repeat(25, 50px);\n  }\n}\n@media (width: 1024px) {\n  .flexing {\n    grid-template-columns: repeat(1, 390px);\n    /* grid-template-rows: repeat(17, 50px); */\n    grid-auto-flow: row;\n  }\n}\n\n/* @media (max-width: 2304px) {\n  .flexing {\n    grid-template-columns: repeat(5, 400px);\n    grid-template-rows: repeat(10, 50px);\n  }\n} */\n\n.listbody .sp .listbody-right p {\n  max-width: 303px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dropdown {\n  padding: 5px;\n}\n.dropdown .selectfolder {\n  height: 30px;\n  border: none;\n  border-radius: 5px;\n}\n.addtobutton {\n  margin-top: 10px !important;\n  margin-left: 5px !important;\n  height: 30px !important;\n  border: solid 0.5px black !important;\n}\n.statusmessage {\n  padding: 34px;\n  border: 4px black solid;\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n  height: fit-content;\n  background-color: rgb(195, 210, 235);\n  position: absolute;\n  top: 45%;\n  left: 40%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
